import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.less']
})
export class PaginationComponent implements OnInit {
  currentPage: number;
  pages: any[] = [];
  @Input() loadingState: boolean;
  @Input() countPages: number;
  @Output() pageChange = new EventEmitter<any>();

  public ngOnInit() {
    this.getPages(1);
  }

  public getPages(currentPage: number) {
    let lastPage;
    this.currentPage = currentPage;
    this.pages = [];
    let firstPage = (currentPage < 4) ? 1 : currentPage - 3;
    if ((this.countPages - 3) < currentPage || this.countPages < 7) {
      lastPage = this.countPages;
      if (lastPage > 7) firstPage = lastPage - 6;
      if (currentPage > 4 && currentPage < 8) firstPage = 1;
    } else {
      lastPage = firstPage + 6;
    }

    for (let i = firstPage; i <= lastPage; i++) {
      const active = (i === currentPage) ? true : false;
      this.pages.push({ num: i, active: active });
    }
  }

  public changePage(page: number, e: Event) {
    e.preventDefault();
    if (this.loadingState) return;
    this.pageChange.emit(page);
    this.getPages(page);
  }
}
